import { useState } from "react"
import { useQuery, useMutation } from "@apollo/client"
import { toast } from "sonner"

import {
  FETCH_DEPOSITNOTICE,
  HANDLE_DEPOSITNOTICE,
} from "../../../graphql/notice"
import CustomEditor from "../Notice/CustomEditor"
import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Spinner } from "@/components/ui/spinner"

export default function DepositNotice() {
  const { loading, error, data } = useQuery(FETCH_DEPOSITNOTICE)
  const [handleDepositNotice] = useMutation(HANDLE_DEPOSITNOTICE, {
    refetchQueries: [{ query: FETCH_DEPOSITNOTICE }],
    onCompleted: () => toast.success("등록되었습니다"),
    onError: (err) => toast.error(`등록 실패: ${err.message}`),
  })

  const [content, setContent] = useState<string | null>(null)

  if (error) return <div className="text-destructive p-4">오류가 발생했습니다</div>
  if (loading) return <Spinner size="lg" />

  const currentContent = content ?? data?.fetchDepositNotice?.content ?? ""

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    handleDepositNotice({ variables: { content: currentContent } })
  }

  return (
    <div className="h-full flex flex-col">
      <Card className="flex-1 min-h-0 flex flex-col">
        <CardContent className="p-6 flex-1 min-h-0 flex flex-col">
          <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0 gap-4">
            <div className="flex-1 min-h-0">
              <CustomEditor
                containerClassName="h-full"
                value={currentContent}
                onChange={(val: string) => setContent(val)}
              />
            </div>
            <Button type="submit" className="w-full shrink-0">
              등록
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
